const regExp = /\$([^\$]*)\$/gi;
// const altRegExp = /\|(?<alt>.*)\|/i;
const altRegExp = /%([^\$]*)%/gi;

export const getAlt = (value: PictureRef) => {
    if (!value) { return '' }

    const legend = value.Legend;
    if (!legend) { return '' }

    const v = legend.match(altRegExp);

    if (!v) { 
        return legend.replace(/\$/g, '');
    }
    return v[0].replace(/%/g, '');
}

export const getLegend = (value: PictureRef) => {
    if (!value) { return '' }
    
    const legend = value.Legend;
    if (!legend) { return '' }

    const noAlt = legend.replace(altRegExp, '');

    return noAlt.replace(regExp, (m, g) => `<em>${g}</em>`);
}


// WEBPACK FOOTER //
// ./src/utils/legendAlt.ts